import ChecklistService from '@/api/ChecklistService.js'
import Vue from 'vue'
export const checklistModule = {
  namespaced: true,
  state: () => ({
    checklistData: [],
    checklistLoadStatus: 'request',
    paginationChecklistStateParams: {
      count: 0,
      limit: 5,
      total: 0,
      page: 0
    }
  }),

  getters: {
    numPages: (state) =>
      Math.ceil(
        state.paginationChecklistStateParams.total /
        state.paginationChecklistStateParams.limit
      )
  },
  mutations: {
    get_all(state, data) {
      state.checklistData = [...data]
    },
    create(state, data) {
      state.checklistData.unshift(data[0])
    },
    edit_multiple(state, data) {
      let indexed = state.checklistData.findIndex(
        (x) => x.checklist_progress__id == data.id
      )
      Object.assign(state.checklistData[indexed], data.dataEdit)
    },

    delete_data(state, id) {
      let indexed = state.checklistData.findIndex(
        (x) => x.checklist_progress__id == id
      )
      state.checklistData.splice(indexed, 1)
    },

    update_pagination(state, { total, count, limit, page }) {
      state.paginationChecklistStateParams = { total, count, limit, page }
    },

    load_request(state, status) {
      state.checklistLoadStatus = 'request'
    },
    load_success(state) {
      state.checklistLoadStatus = 'success'
    },
    load_error(state) {
      state.checklistLoadStatus = 'error'
    }
  },
  actions: {
    getChecklistAll({ commit }, params) {
      commit('load_request')
      ChecklistService.getAll(params)
        .then((data) => {
          commit('update_pagination', data.data.data)
          commit('get_all', data.data.data.rows)
          commit('load_success')
        })
        .catch((error) => {
          Vue.$toast.error('Ошибка загрузки', { duration: 5000 })
          commit('load_error')
        })
    },

    createChecklistData({ commit }, createData) {
      ChecklistService.create(createData)
        .then((data) => {
          commit('create', data.data.data.rows)
          Vue.$toast.success('Запись добавлена')
        })
        .catch((error) => {
          Vue.$toast.error('Ошибка загрузки', { duration: 5000 })
        })
    },

    editChecklistMultiple({ commit }, { id, dataEdit, type }) {
      ChecklistService.editMultiple(id, dataEdit)
        .then((data) => {
          commit('edit_multiple', { id, dataEdit })

          if (type == 'status') {
            commit('delete_data', id)
          }
          Vue.$toast.success('Данные успешно обновлены')
        })
        .catch((error) => {
          Vue.$toast.error(error.response.data.message, { duration: 5000 })
        })
    },

    deleteChecklistData({ commit }, id) {
      // commit("load_request");
      ChecklistService.delete(id)
        .then((data) => {
          commit('delete_data', id)
          Vue.$toast.success('Данные успешно удалены')
        })
        .catch((error) => {
          Vue.$toast.error('Ошибка загрузки', { duration: 5000 })
        })
    }
  }
}
